import ShippingQuoteMixin from './ShippingQuoteMixin'

export default {
    mixins: [
        ShippingQuoteMixin
    ]
}